<div class="fascicle-auto-form">
  <p-progressBar
    mode="indeterminate"
    *ngIf="!loadedForm"
  ></p-progressBar>

  <ng-container *ngIf="loadedForm">

    <!-- Lista de configuraciones de fascículo -->
    <div
      *ngFor="let config of fascicleConfigs; let i = index; trackBy: trackByConfigId"
      class="config-card"
    >
      <!-- Cabecera de la tarjeta -->
      <div class="cc-page-header cc-page-header--form">
        <div class="cc-page-header-title">
          <i class="pi pi-book"></i>
          <span>{{ config.name || ('FASCICLE.CONFIG_N' | translate: { n: i + 1 }) }}</span>
          <p-badge *ngIf="config.status === 'done'" severity="success" value="✓"></p-badge>
          <p-badge *ngIf="config.status === 'error'" severity="danger" value="!"></p-badge>
          <p-progressSpinner
            *ngIf="config.status === 'generating'"
            strokeWidth="6"
            [style]="{ width: '16px', height: '16px' }"
          ></p-progressSpinner>
        </div>
        <div class="cc-page-header-meta">
          <span class="config-header-count">
            <p-progressSpinner
              *ngIf="config.searchingProducts"
              strokeWidth="7"
              [style]="{ width: '14px', height: '14px' }"
            ></p-progressSpinner>
            <ng-container *ngIf="!config.searchingProducts">
              <span>{{ 'FASCICLE.TOTAL_PRODUCT_FOUND' | translate }}</span>
              <strong [class.text-red-400]="config.totalProducts === 0">
                {{ config.totalProducts }}/{{ totalCatalogProducts }}
              </strong>
            </ng-container>
          </span>
          <p-button
            *ngIf="fascicleConfigs.length > 1"
            icon="pi pi-trash"
            severity="danger"
            [text]="true"
            size="small"
            (onClick)="removeFascicleConfig(i)"
          ></p-button>
        </div>
      </div>

      <div class="config-body">

        <!-- SECCIÓN 1: Información básica -->
        <section class="form-section">
          <h4 class="section-title">{{ 'FASCICLE.SECTION_BASIC' | translate }}</h4>

          <div class="field">
            <label>{{ 'FASCICLE.NAME' | translate }} *</label>
            <input
              pInputText
              [(ngModel)]="config.name"
              [placeholder]="'FASCICLE.NAME' | translate"
              class="w-full"
            />
          </div>

          <div class="field">
            <label>{{ 'FASCICLE.TEMPLATES' | translate }} *</label>
            <p-dropdown
              [options]="templateOptions"
              [(ngModel)]="config.defaultTemplate"
              optionLabel="label"
              optionValue="value"
              [style]="{ width: '100%' }"
            ></p-dropdown>
          </div>
        </section>

        <!-- SECCIÓN 2: Filtros -->
        <section class="form-section">
          <h4 class="section-title">{{ 'FASCICLE.SECTION_FILTERS' | translate }}</h4>

          <div class="field">
            <label>{{ 'FASCICLE.CATEGORIES' | translate }}</label>
            <div class="border-1 surface-border border-round">
              <p-tree
                [value]="categoryTreeNodes"
                selectionMode="checkbox"
                [(selection)]="config.selectedCategoryNodes"
                (onNodeSelect)="onCategoriesChange(config)"
                (onNodeUnselect)="onCategoriesChange(config)"
                [style]="{ width: '100%', border: 'none' }"
              ></p-tree>
            </div>
          </div>

          <div class="field">
            <label>{{ 'FASCICLE.TAGS' | translate }}</label>
            <p-multiSelect
              [options]="tagOptions"
              [(ngModel)]="config.tags"
              optionLabel="label"
              optionValue="value"
              display="chip"
              [style]="{ width: '100%' }"
              (onChange)="onTagsChange(config)"
            ></p-multiSelect>
          </div>
        </section>

        <!-- SECCIÓN 3: Ordenación -->
        <section class="form-section">
          <h4 class="section-title">{{ 'FASCICLE.SECTION_SORT' | translate }}</h4>

          <div class="sort-rules-list">
            <div
              *ngFor="let rule of config.sortRules; let ri = index"
              class="sort-rule-row"
            >
              <div class="sort-rule-order">
                <p-button icon="pi pi-angle-up" [text]="true" size="small" severity="secondary"
                  [disabled]="ri === 0" (onClick)="moveSortRule(config, ri, -1)"></p-button>
                <p-button icon="pi pi-angle-down" [text]="true" size="small" severity="secondary"
                  [disabled]="ri === config.sortRules.length - 1" (onClick)="moveSortRule(config, ri, 1)"></p-button>
              </div>
              <span class="sort-rule-index">{{ ri + 1 }}</span>
              <p-dropdown
                [options]="productFieldOptions"
                [(ngModel)]="rule.field"
                optionLabel="label"
                optionValue="value"
                [placeholder]="'FASCICLE.SORT_SELECT_FIELD' | translate"
                [style]="{ flex: 1 }"
              ></p-dropdown>
              <p-selectButton
                [options]="directionOptions"
                [(ngModel)]="rule.direction"
                optionLabel="label"
                optionValue="value"
              ></p-selectButton>
              <p-button icon="pi pi-trash" severity="danger" [text]="true" size="small"
                (onClick)="removeSortRule(config, ri)"></p-button>
            </div>
          </div>

          <p-button
            icon="pi pi-plus"
            [label]="'FASCICLE.ADD_SORT_RULE' | translate"
            severity="secondary"
            [text]="true"
            size="small"
            (onClick)="addSortRule(config)"
          ></p-button>
        </section>

        <!-- SECCIÓN 4: Reglas de generación -->
        <section class="form-section">
          <h4 class="section-title">{{ 'FASCICLE.SECTION_GENERATION' | translate }}</h4>

          <div class="generation-rules">
            <div class="field-row">
              <p-inputSwitch [(ngModel)]="config.generationRules.fillEmptyCells" [inputId]="'fillEmpty_' + config.id"></p-inputSwitch>
              <label [for]="'fillEmpty_' + config.id">{{ 'FASCICLE.FILL_EMPTY_CELLS' | translate }}</label>
            </div>
            <div class="field-row">
              <p-inputSwitch [(ngModel)]="config.generationRules.skipUnavailable" [inputId]="'skipUnavail_' + config.id"></p-inputSwitch>
              <label [for]="'skipUnavail_' + config.id">{{ 'FASCICLE.SKIP_UNAVAILABLE' | translate }}</label>
            </div>
            <div class="field-row field-row--spread">
              <label>{{ 'FASCICLE.DUPLICATE_STRATEGY' | translate }}</label>
              <p-selectButton
                [options]="duplicateStrategyOptions"
                [(ngModel)]="config.generationRules.duplicateStrategy"
                optionLabel="label"
                optionValue="value"
              ></p-selectButton>
            </div>
          </div>
        </section>

      </div>
    </div>

    <!-- Botón añadir fascículo -->
    <div class="add-config-row">
      <p-button
        icon="pi pi-plus"
        [label]="'FASCICLE.ADD_CONFIG' | translate"
        severity="secondary"
        [outlined]="true"
        (onClick)="addFascicleConfig()"
      ></p-button>
    </div>

    <!-- Barra de progreso global (solo durante la generación) -->
    <div *ngIf="spinnerSave" class="progress-bar-row">
      <p-progressBar
        [value]="overallProgress.total > 0 ? (overallProgress.current / overallProgress.total) * 100 : 0"
        [showValue]="false"
        [style]="{ flex: 1, height: '6px' }"
      ></p-progressBar>
      <span>{{ overallProgress.current }} / {{ overallProgress.total }}</span>
    </div>

    <!-- Acciones -->
    <div class="actions-row">
      <p-button
        [label]="'FORM.SAVE' | translate"
        severity="primary"
        [disabled]="!isFormValid() || spinnerSave"
        (onClick)="save()"
      ></p-button>
      <p-button
        [label]="'FORM.CANCEL' | translate"
        severity="secondary"
        [outlined]="true"
        (onClick)="cancel()"
      ></p-button>
    </div>

  </ng-container>
</div>
